var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMiniinstalogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.008,
    x2: 0.5,
    y2: 0.998,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e09b3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#c74c4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#c21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024c4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: -0.451,
    y2: 1.462,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: -1.396,
    y2: 6.586,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14182",
    "data-name": "Group 14182",
    transform: "translate(-1276 -3935)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(1276 3935)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "instagram",
    transform: "translate(1283.599 3942.446)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33800",
    "data-name": "Path 33800",
    d: "M11.246,0H4.772A4.777,4.777,0,0,0,0,4.772v6.474a4.777,4.777,0,0,0,4.772,4.772h6.474a4.777,4.777,0,0,0,4.772-4.772V4.772A4.777,4.777,0,0,0,11.246,0Zm3.16,11.246a3.16,3.16,0,0,1-3.16,3.16H4.772a3.16,3.16,0,0,1-3.16-3.16V4.772a3.16,3.16,0,0,1,3.16-3.16h6.474a3.16,3.16,0,0,1,3.16,3.16v6.474Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33801",
    "data-name": "Path 33801",
    d: "M137.143,133a4.143,4.143,0,1,0,4.143,4.143A4.147,4.147,0,0,0,137.143,133Zm0,6.674a2.531,2.531,0,1,1,2.531-2.531A2.531,2.531,0,0,1,137.143,139.674Z",
    transform: "translate(-129.134 -129.134)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_43",
    "data-name": "Ellipse 43",
    cx: 0.993,
    cy: 0.993,
    r: 0.993,
    transform: "translate(11.167 2.904)",
    fill: "url(#linear-gradient-3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniinstalogo);
export default __webpack_public_path__ + "static/media/miniinstalogo.a4d8a8a267bc0b41ecc6f68e7d43d49e.svg";
export { ForwardRef as ReactComponent };